/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import {
  Modal, Checkbox, Form, Icon, Popup
} from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import $ from 'jquery';
import { Scrollbars } from 'react-custom-scrollbars-2';
import cx from 'classnames';
import Update from 'immutability-helper';
import Loader from '../Loader/Loader';
import api from '../../api';
import closeBtn from '../../images/components/new_scan/close-btn.svg';
import userPic from '../../images/common/profile_icon_big.png';
import AssigningUserModal from './AssigningUserModal';
import ApplyingPolicyModal from './ApplyingPolicyModal';
import AssigningGroupModal from './AssigningGroupModal';
import AddUserDefinedModal from './AddUserDefinedModal';
import WithRouter from '../Extensions/WithRouter';
import ResultRenderer from '../ResultRenderer/ResultRenderer';

class NewProjectModal extends Component {
  constructor(props) {
    super(props);
    this.typingTimeout = null;
    this.nameInput = React.createRef();
    this.projectNM = React.createRef();
    this.projectMB = React.createRef();
    this.versionInput = React.createRef();
    this.projectVersionNM = React.createRef();
    this.appliedPL = React.createRef();
    this.appliedUD = React.createRef();

    this.state = {
      isOpenMCP: props.isOpenMCP,
      isOpenMAU: false,
      isOpenMAC: false,
      isOpenMAG: false,
      isOpenMUD: false,
      viewPoint: '1',
      versionList: [],
      projectName: '',
      projectNameError: '',
      description: '',
      projectVersion: '',
      projectVersionError: '',
      selectedMemberList: [{
        id: props.state.user.id,
        profile: props.state.user.name,
        email: props.state.user.email,
        type: 'user'
      }],
      selectedPolicyList: [],
      selectedGroupIds: [],
      selectedUserDefinedList: [],
      checkValue: [],
      isPolicyChecked: false,
      policyValues: [],
      appliedPolicerError: '',
      itemsChecked: false,
      modalAlertMsg: '',
      modalAlertTitle: '',
      modalAlert: false,
      isLoader: false,
      isUserdefinedCheckedAll: false,
      userDefinedValues: [],
      copied: false,
      tooltipWithKeyName: '',
      tooltipWithDetailValue: '',
      declaredLicense: '',
      revertDeclaredLicense: '',
      resultList: [],
      isActiveResult: false,
      selectedResultData: '',
      isOpenAttentionModal: false,
      excludePolicyIds: [],
    };
    this.handleViewPostion = this.handleViewPostion.bind(this);
    this.handleAddUser = this.handleAddUser.bind(this);
    this.handleMAUClose = this.handleMAUClose.bind(this);
    this.handleMACClose = this.handleMACClose.bind(this);
    this.handleMAGClose = this.handleMAGClose.bind(this);
    this.handleProjectNameChange = this.handleProjectNameChange.bind(this);
    this.handleDescChange = this.handleDescChange.bind(this);
    this.handleAddNewVersion = this.handleAddNewVersion.bind(this);
    this.handleRemoveUser = this.handleRemoveUser.bind(this);
    this.handleProjectVersionChange = this.handleProjectVersionChange.bind(this);
    this.handleMemberList = this.handleMemberList.bind(this);
    this.handleMemberCheckChange = this.handleMemberCheckChange.bind(this);
    this.handleMemberCheckAll = this.handleMemberCheckAll.bind(this);
    this.handlePolicyCheckChange = this.handlePolicyCheckChange.bind(this);
    this.handlePolicyCheckAll = this.handlePolicyCheckAll.bind(this);
    this.handleUserDefinedCheckAllChange = this.handleUserDefinedCheckAllChange.bind(this);
    this.handleUserDefinedCheckChange = this.handleUserDefinedCheckChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleCloseAlert = this.handleCloseAlert.bind(this);
    this.handleAddPolicy = this.handleAddPolicy.bind(this);
    this.handleAddGroup = this.handleAddGroup.bind(this);
    this.handlePolicyList = this.handlePolicyList.bind(this);
    this.handleRemovePolicy = this.handleRemovePolicy.bind(this);
    this.handleAddUserDefined = this.handleAddUserDefined.bind(this);
    this.handleRemoveUserDefined = this.handleRemoveUserDefined.bind(this);
    this.handleAddUserDefinedCallback = this.handleAddUserDefinedCallback.bind(this);
    this.handleMUDClose = this.handleMUDClose.bind(this);
    this.openTooltipWithKeyName = this.openTooltipWithKeyName.bind(this);
    this.closeTooltipWithKeyName = this.closeTooltipWithKeyName.bind(this);
    this.openTooltipWithDetailValue = this.openTooltipWithDetailValue.bind(this);
    this.closeTooltipWithDetailValue = this.closeTooltipWithDetailValue.bind(this);
    this.handleCopy = this.handleCopy.bind(this);
    this.addNewVersion = this.addNewVersion.bind(this);
    this.closeNewProjectModal = this.closeNewProjectModal.bind(this);
    this.handleChangeLicnese = this.handleChangeLicnese.bind(this);
    this.handleFocusOnLicense = this.handleFocusOnLicense.bind(this);
    this.handleBlurOnLicense = this.handleBlurOnLicense.bind(this);
    this.handleLicenseResultSelect = this.handleLicenseResultSelect.bind(this);
    this.closeAttentionModal = this.closeAttentionModal.bind(this);
  }

  componentDidMount() {
    $(document).on('mouseover', '.setting_popup .table_type_3 .strong', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  componentDidUpdate(prevProps) {
    const { isOpenMCP, state } = this.props;

    if (prevProps.isOpenMCP !== isOpenMCP) {
      this.setState({
        isOpenMCP,
        versionList: [],
        projectName: '',
        projectNameError: '',
        description: '',
        projectVersion: '',
        projectVersionError: '',
        appliedPolicerError: '',
        selectedMemberList: [{
          id: state.user.id,
          profile: state.user.name,
          email: state.user.email,
          type: 'user'
        }],
        selectedPolicyList: [],
        selectedGroupIds: [],
        selectedUserDefinedList: [],
        modalAlertMsg: '',
        modalAlertTitle: '',
        viewPoint: '1',
        checkValue: [],
        isPolicyChecked: false,
        itemsChecked: false,
        isLoader: false,
        isUserdefinedCheckedAll: false,
        userDefinedValues: [],
        copied: false,
        tooltipWithKeyName: '',
        tooltipWithDetailValue: '',
        declaredLicense: '',
        revertDeclaredLicense: '',
        resultList: [],
        isActiveResult: false,
        selectedResultData: '',
        isOpenAttentionModal: false,
        excludePolicyIds: [],
      });
    }
  }

  handleSave(event) {
    const { state } = this.props;
    const {
      projectName, versionList, description, declaredLicense
    } = this.state;
    event.preventDefault();

    const newArray = [];
    const groupIds = [];
    const policyIds = [];
    const userDefinedIds = [];

    let l = 0;
    let m = 0;
    const { selectedMemberList, selectedPolicyList, selectedUserDefinedList } = this.state;
    const { translate } = this.props;

    selectedMemberList.map((item) => {
      return newArray.push(item.email);
    });

    if (newArray.indexOf(state.user.email) === -1) {
      newArray.push(state.user.email);
    }

    for (l; l < selectedPolicyList.length; l++) {
      policyIds.push(selectedPolicyList[l].id);
    }

    for (m; m < selectedMemberList.length; m++) {
      if (selectedMemberList[m].type === 'group') {
        groupIds.push(selectedMemberList[m].id);
      }
    }

    selectedUserDefinedList.map((item) => {
      return userDefinedIds.push(item.user_defined_id);
    });

    const formData = {
      name: projectName,
      description,
      versions: versionList,
      owners: [state.user.email],
      policy_ids: policyIds,
      group_ids: groupIds,
      members: newArray,
      user_defined_ids: userDefinedIds,
      declared_license: declaredLicense.trim(),
    };

    if (!this.validateFields()) {
      return null;
    }

    this.setState({
      modalAlert: true,
      isLoader: true,
    });

    api
      .createSProject(formData)
      .then(() => {
        this.setState({
          isLoader: false,
          modalAlertTitle: translate('modal.title.notice'),
          modalAlertMsg: translate('modal.message.create_project'),
        });
      })
      .catch((err) => {
        console.log(err);
        const o = err.data.response;
        if (o.error === '422-356') {
          this.setState({
            projectNameError: translate('modal.error.duplicate_project'),
            modalAlert: false,
          });
          this.nameInput.current.focus();
          this.projectNM.current.scrollIntoView();
        } else if (o.error === '422-357') {
          this.setState({
            projectVersionError: translate('modal.error.duplicate_project_version'),
            modalAlert: false,
          });
          this.versionInput.current.focus();
          this.projectVersionNM.current.scrollIntoView();
        } else if (o.error === '422-358') {
          this.setState({
            projectVersionError: translate('modal.error.error_422_358'),
            modalAlert: false,
          });
          this.versionInput.current.focus();
          this.projectVersionNM.current.scrollIntoView();
        } else if (o.error === '422-354') {
          this.setState({
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: translate('modal.error.error_422_354'),
          });
        } else if (o.error === '422-355') {
          this.setState({
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: translate('modal.error.error_422_355'),
          });
        } else if (o.error === '422-359') {
          this.setState({
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: translate('modal.error.error_422_359'),
          });
        } else {
          this.setState({
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: o.error_description || translate('modal.error.unknow_error'),
          });
        }
        this.setState({
          //isLoading: false,
          isLoader: false,
        });
      });
  }

  handleCloseAlert() {
    const { completeCallback } = this.props;
    const { modalAlertTitle } = this.state;
    if (!modalAlertTitle) {
      this.setState({ modalAlert: false });
      return false;
    }
    this.setState({ modalAlert: false });
    completeCallback(200);
    this.closeNewProjectModal();
  }

  handleAddNewVersion(event) {
    if (event.key === 'Enter') {
      this.addNewVersion();
    }
  }

  handleViewPostion(e) {
    if (e.currentTarget.dataset.id === '1') {
      this.projectNM.current.scrollIntoView();
    } else if (e.currentTarget.dataset.id === '2') {
      this.projectMB.current.scrollIntoView();
    } else if (e.currentTarget.dataset.id === '3') {
      this.appliedPL.current.scrollIntoView();
    } else if (e.currentTarget.dataset.id === '4') {
      this.appliedUD.current.scrollIntoView();
    }
    this.setState({
      viewPoint: e.currentTarget.dataset.id,
    });
  }

  handleProjectNameChange(e) {
    this.setState({
      projectName: e.target.value,
      projectNameError: '',
    });
  }

  handleDescChange(e) {
    this.setState({
      description: e.target.value,
      //descriptionError: '',
    });
  }

  handleAddPolicy() {
    const { selectedPolicyList } = this.state;

    const excludeIds = selectedPolicyList.map((item) => {
      return item.id;
    });

    this.setState({
      isOpenMAC: true,
      excludePolicyIds: excludeIds,
    });
  }

  handleAddGroup() {
    this.setState({
      isOpenMAG: true,
    });
  }

  handleProjectVersionChange(e) {
    const { translate } = this.props;
    if (this.getByteLength(e.target.value) > 20) {
      this.setState({
        projectVersionError: translate('modal.error.version_limited_char'),
      });
      return false;
    }
    this.setState({
      projectVersion: e.target.value,
      projectVersionError: '',
    });
  }

  handleMemberCheckChange(e, { value }) {
    const { checkValue } = this.state;
    let newState;
    if (checkValue.indexOf(value) > -1) {
      newState = checkValue.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...checkValue, value];
    }
    this.setState({
      checkValue: newState,
    });
  }

  handleMemberCheckAll() {
    const { state } = this.props;
    const { itemsChecked, selectedMemberList } = this.state;
    const newState = [];

    if (itemsChecked) {
      this.setState({
        itemsChecked: false,
        checkValue: [],
      });
    } else {
      const newData = selectedMemberList.filter((item) => {
        return item.email !== state.user.email;
      });
      const num = newData.length;
      let i = 0;
      for (i; i < num; i++) {
        newState.push(`${newData[i].type}_${newData[i].id}`);
      }

      const unique = newState.reduce((a, b) => {
        if (a.indexOf(b) < 0) {
          a.push(b);
        }
        return a;
      }, []);

      this.setState({
        itemsChecked: true,
        checkValue: unique,
      });
    }
  }

  handlePolicyCheckChange(e, { value }) {
    const { policyValues } = this.state;
    let newState;
    if (policyValues.indexOf(value) > -1) {
      newState = policyValues.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...policyValues, value];
    }
    this.setState({
      policyValues: newState,
    });
  }

  handlePolicyCheckAll() {
    const { isPolicyChecked, selectedPolicyList } = this.state;
    const newState = [];

    if (isPolicyChecked) {
      this.setState({
        isPolicyChecked: false,
        policyValues: [],
      });
    } else {
      const num = selectedPolicyList.length;
      let i = 0;
      for (i; i < num; i++) {
        newState.push(selectedPolicyList[i].id);
      }

      const unique = newState.reduce((a, b) => {
        if (a.indexOf(b) < 0) {
          a.push(b);
        }
        return a;
      }, []);
      this.setState({
        isPolicyChecked: true,
        policyValues: unique,
      });
    }
  }

  handleUserDefinedCheckAllChange() {
    this.setState((prevState) => {
      const { isUserdefinedCheckedAll, selectedUserDefinedList } = prevState;
      if (isUserdefinedCheckedAll) {
        return {
          isUserdefinedCheckedAll: false,
          userDefinedValues: [],
        };
      }
      const newState = selectedUserDefinedList.map((item) => { return item.user_defined_id; });
      const unique = [...new Set(newState)];
      return {
        isUserdefinedCheckedAll: true,
        userDefinedValues: unique,
      };

    });
  }

  handleUserDefinedCheckChange(e, { value }) {
    this.setState((prevState) => {
      const { userDefinedValues, selectedUserDefinedList } = prevState;

      const newValue = userDefinedValues.includes(value)
        ? userDefinedValues.filter((el) => { return el !== value; })
        : [...userDefinedValues, value];

      const allSelected = userDefinedValues.length > 0 && selectedUserDefinedList.every((item) => { return newValue.includes(item.user_defined_id); });

      return {
        userDefinedValues: newValue,
        isUserdefinedCheckedAll: allSelected,
      };
    });
  }

  handleMemberList(newArr) {
    const newIds = [];
    let i = 0;
    const { selectedMemberList } = this.state;

    this.setState({
      selectedMemberList: Update(selectedMemberList, {
        $push: newArr,
      }),
    }, () => {
      const groupList = selectedMemberList.filter((item) => {
        return item.type === 'group';
      });
      if (groupList.length !== 0) {
        for (i; i < groupList.length; i++) {
          newIds.push(groupList[i].id);
        }
        this.setState({
          selectedGroupIds: newIds,
        });
      }
    });
  }

  handlePolicyList(newArr) {
    const { selectedPolicyList } = this.state;

    this.setState({
      selectedPolicyList: Update(selectedPolicyList, {
        $push: newArr,
      }),
    });
  }

  handleAddUser() {
    this.setState({
      isOpenMAU: true,
    });
  }

  handleRemoveUser() {
    const { checkValue, selectedMemberList } = this.state;
    const newIds = [];
    let i = 0;

    if (checkValue.length === 0) {
      return false;
    }
    const newState = selectedMemberList.filter((item) => {
      return checkValue.indexOf(`${item.type}_${item.id}`) === -1;
    });

    this.setState({
      selectedMemberList: newState,
      checkValue: [],
      itemsChecked: false,
    }, () => {
      const groupList = selectedMemberList.filter((item) => {
        return item.type === 'group';
      });
      if (groupList.length !== 0) {
        for (i; i < groupList.length; i++) {
          newIds.push(groupList[i].id);
        }

        this.setState({
          selectedGroupIds: newIds,
        });
      } else {
        this.setState({
          selectedGroupIds: newIds,
        });
      }
    });
  }

  handleRemovePolicy() {
    const { policyValues, selectedPolicyList } = this.state;
    if (policyValues.length === 0) {
      return false;
    }
    const newState = selectedPolicyList.filter((item) => {
      return policyValues.indexOf(item.id) === -1;
    });
    this.setState({
      selectedPolicyList: newState,
      policyValues: [],
      isPolicyChecked: false,
    });
  }

  handleAddUserDefined() {
    this.setState({
      isOpenMUD: true,
    });
  }

  handleRemoveUserDefined() {
    const { selectedUserDefinedList, userDefinedValues } = this.state;
    const newData = selectedUserDefinedList.filter((item) => {
      return !userDefinedValues.includes(item.user_defined_id);
    });

    this.setState({
      selectedUserDefinedList: newData,
      isUserdefinedCheckedAll: false,
    });

  }

  handleAddUserDefinedCallback(rowData) {
    const { selectedUserDefinedList } = this.state;
    this.setState({
      selectedUserDefinedList: [...selectedUserDefinedList, ...rowData],
    });
  }

  handleMAUClose() {
    this.setState({
      isOpenMAU: false,
    });
  }

  handleMACClose() {
    this.setState({
      isOpenMAC: false,
      excludePolicyIds: [],
    });
  }

  handleMAGClose() {
    this.setState({
      isOpenMAG: false,
    });
  }

  handleMUDClose() {
    this.setState({
      isOpenMUD: false,
    });
  }

  handleCopy(value) {
    navigator.clipboard.writeText(value).then(() => {
      this.setState({ copied: true }, () => {
        setTimeout(() => { return this.setState({ copied: false }); }, 2000);
      });
    }).catch((err) => { return console.error('Copy failed', err); });
  }

  handleChangeLicnese = (e) => {
    const { translate } = this.props;
    const string = e.target.value;
    const trimmedString = string.replace(/\s/g, '');

    if (trimmedString === '' && string !== '') {
      this.modalAction = translate('modal.title.attention');
      this.modalBody = translate('modal.message.search_string_with_space');
      this.setState({
        isOpenAttentionModal: true,
      });
      return;
    }

    this.setState({
      declaredLicense: string,
    });

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }

    if (string === '') {
      this.setState({
        revertDeclaredLicense: '',
        selectedResultData: '',
      });
    }

    this.typingTimeout = setTimeout(() => {
      this.searchDeclaredLicense(string);
    }, 1000);
  };

  handleFocusOnLicense = () => {
    const { declaredLicense, revertDeclaredLicense } = this.state;
    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }

    const searchKeyword = '';

    this.setState({
      selectedResultData: '',
    });

    if (declaredLicense === revertDeclaredLicense) {
      this.typingTimeout = setTimeout(() => {
        this.searchDeclaredLicense(declaredLicense);
      }, 300);
    } else {
      this.typingTimeout = setTimeout(() => {
        this.searchDeclaredLicense(searchKeyword);
      }, 300);
    }
  };

  handleBlurOnLicense = () => {
    const { selectedResultData, revertDeclaredLicense } = this.state;

    if (selectedResultData === '') {
      this.setState({
        declaredLicense: revertDeclaredLicense,
      });
    }
    this.setState({
      isActiveResult: false,
    });
  };

  handleLicenseResultSelect = (e, result) => {
    this.setState({
      isActiveResult: false,
      declaredLicense: result.name,
      revertDeclaredLicense: result.name,
      selectedResultData: result.name,
    });
  };

  getProfileImg(value) {
    const profileImg = `/1/users/me/profile_image/${value}`;

    let baseUrl = '//'.concat(location.hostname);
    let profileImgUrl = '';

    if (process.env.NODE_ENV === 'development') {
      baseUrl = baseUrl.concat(':3000');
    } else {
      baseUrl = location.port !== '' ? baseUrl.concat(':', location.port) : '';
    }

    profileImgUrl = profileImg !== '' ? baseUrl.concat(profileImg) : userPic;

    return profileImgUrl;
  }

  getByteLength(text) {
    let l = 0;
    for (let i = 0; i < text.length; i++) l += (text.charCodeAt(i) > 128) ? 2 : 1;
    // return text.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, '$&$1$2').length;
    return l;
  }

  deleteNewVersion = (e, index) => {
    const { versionList } = this.state;
    e.preventDefault();
    let newState = [];
    newState = { $splice: [[index, 1]] };
    this.setState({
      versionList: Update(versionList, newState),
    });
  };

  addNewVersion() {
    const { projectVersion, versionList } = this.state;
    const { translate } = this.props;

    let isUnique = false;
    if (projectVersion.trim().length === 0) {
      this.setState({
        projectVersionError: translate('modal.error.project_version_required'),
      });
      this.projectVersionNM.current.scrollIntoView();
      return false;
    }
    if (this.getByteLength(projectVersion) > 20) {
      this.setState({
        projectVersionError: translate('modal.error.version_limited_char'),
      });
      this.projectVersionNM.current.scrollIntoView();
      return false;
    }
    if (versionList.length !== 0) {
      const checkUnique = versionList.filter((item) => {
        return projectVersion === item;
      });
      if (checkUnique.length !== 0) {
        isUnique = true;
      }
    }
    if (isUnique) {
      this.setState({
        projectVersionError: translate('modal.error.duplicate_project_version'),
      });
      this.projectVersionNM.current.scrollIntoView();
    } else {
      this.setState({
        projectVersion: '',
        versionList: [projectVersion, ...versionList],
      });
    }
  }

  searchDeclaredLicense(searchKeyword) {
    api
      .searchDeclaredLicense({
        search: searchKeyword,
        limit: 25,
      })
      .then((response) => {
        const data = response.response;
        const newData = data.map((item, index) => {
          return {
            id: index,
            name: item,
          };
        });

        if (searchKeyword !== '' && data.indexOf(searchKeyword) === -1) {
          const newComponent = {
            id: 'exact',
            name: searchKeyword,
          };
          newData.unshift(newComponent);
        }

        this.setState({
          isActiveResult: true,
          resultList: newData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  validateFields() {
    const { projectName, versionList, selectedPolicyList } = this.state;
    const { translate } = this.props;

    const validation = {
      projectName: true,
      projectVersion: true,
      selectedPolicy: true,
    };

    if (projectName.trim().length === 0) {
      this.setState({
        projectNameError: translate('modal.error.project_required'),
      });
      if (this.projectNM?.current) {
        this.projectNM.current.scrollIntoView();
      }
      if (this.nameInput?.current) {
        this.nameInput.current.focus();
      }
      validation.projectName = false;
      return false;
    }
    if (this.getByteLength(projectName) > 30) {
      this.setState({
        projectNameError: translate('modal.error.project_limited_char'),
      });
      if (this.projectNM?.current) {
        this.projectNM.current.scrollIntoView();
      }
      if (this.nameInput?.current) {
        this.nameInput.current.focus();
      }
      validation.projectName = false;
      return false;
    }

    if (versionList.length === 0) {
      this.setState({
        projectVersionError: translate('modal.error.project_version_required'),
      });
      if (this.projectVersionNM?.current) {
        this.projectVersionNM.current.scrollIntoView();
      }
      if (this.versionInput?.current) {
        this.versionInput.current.focus();
      }
      validation.projectVersion = false;
      return false;
    }

    if (selectedPolicyList.length !== 0) {
      const component = [];
      const security = [];
      const license = [];
      const litigator = [];

      selectedPolicyList.forEach((item) => {
        if (item.category === 'component') component.push(item);
        if (item.category === 'security') security.push(item);
        if (item.category === 'license') license.push(item);
        if (item.category === 'litigator') litigator.push(item);
      });

      if (component.length > 1 || security.length > 1 || license.length > 1 || litigator.length > 1) {
        this.setState({
          appliedPolicerError: translate('modal.error.applied_policy_error'),
        });
        if (this.appliedPL?.current) {
          this.appliedPL.current.scrollIntoView();
        }
        validation.selectedPolicy = false;
        return false;
      }
    }

    return validation.projectName && validation.projectVersion && validation.selectedPolicy;
  }

  closeNewProjectModal(e) {
    const { closeModal } = this.props;
    if (e) {
      e.preventDefault();
      if (e.target.classList[0] === 'red_button') {
        return false;
      }
    }
    this.setState({
      isOpenMCP: false,
    });
    closeModal();
  }

  closeAttentionModal() {
    this.setState({
      isOpenAttentionModal: false,
    });
  }

  convertToString(string) {
    if (string === 'clarityadmin@insignary.com') {
      return 'Admin';
    } if (string === 'licensemanager@insignary.com') {
      return 'Licensemanager';
    }
    return string;
  }

  openTooltipWithKeyName(id) {
    this.timeout = setTimeout(() => {
      this.setState({ tooltipWithKeyName: id });
    }, 250);
  }

  closeTooltipWithKeyName() {
    this.setState({ tooltipWithKeyName: '' });
    clearTimeout(this.timeout);
  }

  openTooltipWithDetailValue(id) {
    this.timeout = setTimeout(() => {
      this.setState({ tooltipWithDetailValue: id });
    }, 250);
  }

  closeTooltipWithDetailValue() {
    this.setState({ tooltipWithDetailValue: '' });
    clearTimeout(this.timeout);
  }

  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return (
      `${parseFloat((bytes / (k ** i)).toFixed(dm))} ${sizes[i]}`
    );
  }

  renderTypeValue(rowData) {
    const { translate } = this.props;
    if (rowData.type === 'component') {
      if (rowData.key2 === null || rowData.key2 === '') {
        return translate('list.title.component');
      }
      return translate('list.title.component_version');
    }
    if (rowData.type === 'hash') {
      return translate('settings.list.type_hash');
    }
  }

  renderKeyName(rowData) {
    const { translate } = this.props;
    const { tooltipWithKeyName, copied } = this.state;
    if (rowData.type === 'hash') {
      return (
        <Popup
          trigger={(
            <span className="tooltip-icon">
              {rowData.key1}
            </span>
          )}
          position="bottom left"
          hoverable
          hideOnScroll
          open={tooltipWithKeyName === rowData.user_defined_id}
          onOpen={() => {
            return this.openTooltipWithKeyName(rowData.user_defined_id);
          }}
          onClose={this.closeTooltipWithKeyName}
        >
          <Form className="popup_list">
            <Form.Field style={{ width: '470px' }}>
              <label>
                {translate('settings.list.sha256')}
                <Icon
                  className={`copy_value ${copied ? 'copied' : ''}`}
                  name="copy outline"
                  onClick={() => { return this.handleCopy(rowData.key1); }}
                  aria-label="Copy to clipboard"
                />
                {copied && <span style={{ marginLeft: '10px', color: '#3f10a6' }}>{translate('settings.list.copied')}</span>}
              </label>
              <Form.Input value={rowData.key1} readOnly />
            </Form.Field>
          </Form>
        </Popup>
      );
    }
    return (
      <Popup
        trigger={(
          <span className="tooltip-icon">
            {rowData.key1}
          </span>
        )}
        position="bottom left"
        hoverable
        hideOnScroll
        open={tooltipWithKeyName === rowData.user_defined_id}
        onOpen={() => {
          return this.openTooltipWithKeyName(rowData.user_defined_id);
        }}
        onClose={this.closeTooltipWithKeyName}
      >
        <Form className="popup_list">
          <Form.Field style={{ width: '150px' }}>
            <label>
              {translate('list.title.component')}
              <Icon
                className={`copy_value ${copied ? 'copied' : ''}`}
                name="copy outline"
                onClick={() => { return this.handleCopy(rowData.key1); }}
                aria-label="Copy to clipboard"
              />
              {copied && <span style={{ marginLeft: '10px', color: '#3f10a6' }}>{translate('settings.list.copied')}</span>}
            </label>
            <Form.Input value={rowData.key1} readOnly />
          </Form.Field>
        </Form>
      </Popup>
    );
  }

  renderKeyNameDetail(rowData) {
    const { translate } = this.props;
    const { tooltipWithDetailValue, copied } = this.state;

    if (rowData.type === 'hash') {
      return (
        <Popup
          trigger={(
            <span className="tooltip-icon">
              {this.formatBytes(rowData.key2)}
            </span>
          )}
          position="bottom left"
          hoverable
          hideOnScroll
          open={tooltipWithDetailValue === rowData.user_defined_id}
          onOpen={() => {
            return this.openTooltipWithDetailValue(rowData.user_defined_id);
          }}
          onClose={this.closeTooltipWithDetailValue}
        >
          <Form className="popup_list">
            <Form.Field style={{ width: '150px' }}>
              <label>
                {translate('settings.list.size')}
                <Icon
                  className={`copy_value ${copied ? 'copied' : ''}`}
                  name="copy outline"
                  onClick={() => { return this.handleCopy(rowData.key2); }}
                  aria-label="Copy to clipboard"
                />
                {copied && <span style={{ marginLeft: '10px', color: '#3f10a6' }}>{translate('settings.list.copied')}</span>}
              </label>
              <Form.Input value={this.formatBytes(rowData.key2)} readOnly />
            </Form.Field>
          </Form>
        </Popup>
      );
    }
    return (
      <Popup
        trigger={(
          <span className="tooltip-icon">
            {rowData.key2}
          </span>
        )}
        position="bottom left"
        hoverable
        hideOnScroll
        open={tooltipWithDetailValue === rowData.user_defined_id}
        onOpen={() => {
          return this.openTooltipWithDetailValue(rowData.user_defined_id);
        }}
        onClose={this.closeTooltipWithDetailValue}
      >
        <Form className="popup_list">
          <Form.Field style={{ width: '150px' }}>
            <label>
              {translate('list.title.component_version')}
              <Icon
                className={`copy_value ${copied ? 'copied' : ''}`}
                name="copy outline"
                onClick={() => { return this.handleCopy(rowData.key2); }}
                aria-label="Copy to clipboard"
              />
              {copied && <span style={{ marginLeft: '10px', color: '#3f10a6' }}>{translate('settings.list.copied')}</span>}
            </label>
            <Form.Input value={rowData.key2} readOnly />
          </Form.Field>
        </Form>
      </Popup>
    );
  }

  render() {
    const {
      viewPoint,
      projectName,
      description,
      projectVersion,
      versionList,
      selectedMemberList,
      selectedPolicyList,
      checkValue,
      itemsChecked,
      policyValues,
      isPolicyChecked,
      projectNameError,
      projectVersionError,
      appliedPolicerError,
      appliedUserDefinedError,
      isOpenMCP,
      isOpenMAU,
      isOpenMAC,
      isOpenMAG,
      isOpenMUD,
      selectedGroupIds,
      selectedUserDefinedList,
      userDefinedValues,
      isUserdefinedCheckedAll,
      modalAlert,
      isLoader,
      modalAlertTitle,
      modalAlertMsg,
      declaredLicense,
      resultList,
      isActiveResult,
      isOpenAttentionModal,
      excludePolicyIds
    } = this.state;
    const { translate, location, state } = this.props;

    const projectNameErrorClass = projectNameError !== '' ? 'show' : '';
    const projectVersionErrorClass = projectVersionError !== '' ? 'show' : '';

    const appliedPolicerErrorClass = appliedPolicerError !== '' ? 'show' : '';

    const appliedUserdefinedErrorClass = appliedUserDefinedError !== '' ? 'show' : '';

    if (state.user.scanConfig.isLoading) {
      return <Loader />;
    }

    return (
      <Modal
        open={isOpenMCP}
        onClose={this.closeNewProjectModal}
      >
        <div className="setting_popup_wrap">
          <div className="setting_popup default_popup has_popup_inner_menu">
            <div className="setting_popup_header">
              <h2 className="popup_name">{translate('modal.title.new_project')}</h2>
              <a
                className="popup_close_button"
                onClick={this.closeNewProjectModal}
                onKeyUp={this.closeNewProjectModal}
              >
                <img src={closeBtn} alt="" />
              </a>
              <div className="popup_inner_menu">
                <a
                  className={cx({
                    active: viewPoint === '1',
                  })}
                  data-id="1"
                  onClick={this.handleViewPostion}
                  onKeyUp={this.handleViewPostion}
                >
                  {translate('modal.title.project_information')}
                </a>
                <a
                  className={cx({
                    active: viewPoint === '3',
                  })}
                  data-id="3"
                  onClick={this.handleViewPostion}
                  onKeyUp={this.handleViewPostion}
                >
                  {translate('settings.list.applied_policy')}
                  (
                  {selectedPolicyList.length}
                  )
                </a>
                <a
                  className={cx({
                    active: viewPoint === '2',
                  })}
                  data-id="2"
                  onClick={this.handleViewPostion}
                  onKeyUp={this.handleViewPostion}
                >
                  {translate('modal.title.project_member')}
                  (
                  {selectedMemberList.length}
                  )
                </a>
                <a
                  className={cx({
                    active: viewPoint === '4',
                  })}
                  data-id="4"
                  onClick={this.handleViewPostion}
                  onKeyUp={this.handleViewPostion}
                >
                  {translate('contents_header.menu.user_defined')}
                  (
                  {selectedUserDefinedList.length}
                  )
                </a>
              </div>
            </div>
            <Scrollbars
              style={{
                position: 'relative',
                overflow: 'hidden',
                height: '100%',
              }}
            >
              <div className="setting_popup_contnets">
                <div className="setting_popup_content_wrap">
                  <h3
                    className="content_title"
                    ref={this.projectNM}
                  >
                    {translate('settings.list.project_name')}
                    <em style={{ marginLeft: '0' }} className="asterisk" />
                  </h3>
                  <div className="setting_popup_content">
                    <input
                      type="text"
                      value={projectName}
                      placeholder={translate('settings.list.project_name')}
                      onChange={this.handleProjectNameChange}
                      ref={this.nameInput}
                    />
                    <div
                      className={`error ${projectNameErrorClass}`}
                      style={{
                        marginTop: '6px',
                        marginLeft: '5px',
                        fontSize: '12px',
                        fontWeight: '700',
                        color: '#ef4136',
                      }}
                    >
                      {projectNameError}
                    </div>
                  </div>
                </div>

                <div className="setting_popup_content_wrap">
                  <h3 className="content_title">{translate('list.title.description')}</h3>
                  <div className="setting_popup_content">
                    <textarea
                      value={description}
                      placeholder={translate('list.title.description')}
                      onChange={this.handleDescChange}
                      rows="3"
                    />
                  </div>
                </div>

                <div className="setting_popup_content_wrap">
                  <h3
                    className="content_title"
                  >
                    {translate('settings.list.declared_license')}
                  </h3>
                  <div className="setting_popup_content" style={{ position: 'relative' }}>
                    <input
                      className=""
                      style={{ width: '25.5%' }}
                      type="text"
                      value={declaredLicense}
                      placeholder={translate('settings.list.declared_license')}
                      onChange={this.handleChangeLicnese}
                      onFocus={this.handleFocusOnLicense}
                      onBlur={this.handleBlurOnLicense}
                    />
                    <ResultRenderer
                      results={resultList}
                      handleResultSelect={this.handleLicenseResultSelect}
                      isShowResult={isActiveResult}
                      translate={translate}
                    />
                  </div>
                </div>

                <div
                  className="setting_popup_content_wrap"
                  ref={this.projectVersionNM}
                >
                  <h3 className="content_title">
                    {translate('list.title.project_version')}
                    <em style={{ marginLeft: '0' }} className="asterisk" />
                  </h3>
                  <div className="setting_popup_content">
                    <table className="table">
                      <colgroup>
                        <col />
                        <col style={{ width: '72px' }} />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td className="with_button">
                            <input
                              type="text"
                              value={projectVersion}
                              placeholder={translate('modal.new_scan.title.new_version')}
                              onKeyPress={this.handleAddNewVersion}
                              onChange={this.handleProjectVersionChange}
                              ref={this.versionInput}
                            />
                            <div
                              className={`error ${projectVersionErrorClass}`}
                              style={{
                                marginTop: '6px',
                                marginLeft: '5px',
                                fontSize: '12px',
                                fontWeight: '700',
                                color: '#ef4136',
                                postion: 'absolute',
                                minHeight: '18px',
                              }}
                            >
                              {projectVersionError}
                            </div>
                          </td>
                          <td className="with_button">
                            <a
                              className="blue_button"
                              style={{ cursor: 'pointer' }}
                              onClick={this.addNewVersion}
                              onKeyUp={this.addNewVersion}
                            >
                              {translate('modal.button.add')}
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="setting_popup_content">
                    <div
                      className="table_wrap table_type_3"
                      style={{
                        padding: '0 10px',
                        border: '1px solid #e5e5e5',
                        borderRadius: '5px',
                      }}
                    >
                      <table className="table table_type_3">
                        <colgroup>
                          <col style={{ width: '' }} />
                          <col style={{ width: '140px' }} />
                          <col style={{ width: '140px' }} />
                          <col style={{ width: '100px' }} />
                          <col style={{ width: '110px' }} />
                          <col style={{ width: '81px' }} />
                        </colgroup>
                        <tbody>
                          <tr>
                            <th>{translate('modal.place_holder.version_name')}</th>
                            <th>{translate('modal.new_scan.place_holder.uploaded_files')}</th>
                            <th>{translate('list.title.scanned_size')}</th>
                            <th>{translate('modal.title.created')}</th>
                            <th>{translate('modal.title.last_updated')}</th>
                            <th>&nbsp;</th>
                          </tr>
                          {versionList.length !== 0 ? (
                            versionList.map((list, index) => {
                              return (
                                <tr key={list.toString()}>
                                  <td className="strong">{list}</td>
                                  <td className="strong">
                                    <div className="number">0</div>
                                  </td>
                                  <td className="strong">
                                    <div className="number">0 MB</div>
                                  </td>
                                  <td className="strong">-</td>
                                  <td className="strong">-</td>
                                  <td className="strong">
                                    <a
                                      className="red_button"
                                      style={{ cursor: 'pointer' }}
                                      onClick={(e) => { return this.deleteNewVersion(e, index); }}
                                      onKeyUp={(e) => { return this.deleteNewVersion(e, index); }}
                                    >
                                      {translate('modal.button.delete')}
                                    </a>
                                  </td>
                                </tr>
                              );
                            })
                          ) : null}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                {/**
                <div className="setting_popup_content_wrap">
                  <h3 className="content_title">Quick Scan</h3>
                  <div className="setting_popup_content">
                    <table className="table">
                      <colgroup>
                        <col style={{ width: '246px' }} />
                        <col />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td>
                            <div className="switch">
                              <a className="checked">On</a>
                              <a>Off</a>
                            </div>
                          </td>
                          <td>&nbsp;</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                */}
                <div className="setting_popup_content_wrap">
                  <h3
                    className="content_title"
                    ref={this.appliedPL}
                  >
                    {translate('settings.list.applied_policy')}
                    (
                    {selectedPolicyList.length}
                    )
                    <div className="button_box">
                      <a
                        className="delete_button"
                        style={{ cursor: 'pointer' }}
                        onClick={this.handleRemovePolicy}
                        onKeyUp={this.handleRemovePolicy}
                      >
                        {translate('modal.button.delete')}
                      </a>
                      <a
                        className="add_button"
                        style={{ cursor: 'pointer' }}
                        onClick={this.handleAddPolicy}
                        onKeyUp={this.handleAddPolicy}
                      >
                        {translate('modal.button.add_policy')}
                      </a>
                    </div>
                  </h3>
                  <div
                    className={`error ${appliedPolicerErrorClass}`}
                    style={{
                      marginTop: '6px',
                      marginLeft: '5px',
                      fontSize: '12px',
                      fontWeight: '700',
                      color: '#ef4136',
                    }}
                  >
                    {appliedPolicerError}
                  </div>
                  <div className="setting_popup_content">
                    <div className="table_wrap table_type_3" style={{ padding: '0 10px', border: '1px solid #e5e5e5', borderRadius: '5px' }}>
                      <table className="table table_type_3" style={{ tableLayout: 'fixed' }}>
                        <colgroup>
                          <col style={{ width: '3.7%' }} />
                          <col style={{ width: '35%' }} />
                          <col style={{ width: '20%' }} />
                          <col style={{ width: '20%' }} />
                          <col style={{ width: '20%' }} />
                        </colgroup>
                        <tbody>
                          <tr>
                            <th>
                              <Checkbox
                                checked={isPolicyChecked}
                                onChange={this.handlePolicyCheckAll}
                                disabled={selectedPolicyList.length === 0}
                              />
                            </th>
                            <th>{translate('modal.title.policy_name')}</th>
                            <th>{translate('settings.list.category')}</th>
                            <th>{translate('settings.list.condition')}</th>
                            <th className="tac">{translate('settings.list.applied')}</th>
                          </tr>
                          {
                            selectedPolicyList.length !== 0 ? (
                              selectedPolicyList.map((item) => {
                                return (
                                  <tr key={item.id}>
                                    <td className="strong">
                                      <Checkbox
                                        value={item.id}
                                        checked={policyValues.indexOf(item.id) > -1}
                                        onChange={this.handlePolicyCheckChange}
                                      />
                                    </td>
                                    <td className="strong">{item.name}</td>
                                    <td className="strong">{item.category}</td>
                                    <td className="strong">{item.condition}</td>
                                    <td className="strong tac">
                                      -
                                    </td>
                                  </tr>
                                );
                              })
                            ) : null
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="setting_popup_content_wrap">
                  <h3
                    className="content_title"
                    ref={this.appliedUD}
                  >
                    {translate('contents_header.menu.user_defined')}
                    (
                    {selectedUserDefinedList.length}
                    )
                    <div className="button_box">
                      <a
                        className="delete_button"
                        style={{ cursor: 'pointer' }}
                        onClick={this.handleRemoveUserDefined}
                        onKeyUp={this.handleRemoveUserDefined}
                      >
                        {translate('modal.button.delete')}
                      </a>
                      <a
                        className="add_button"
                        style={{ cursor: 'pointer' }}
                        onClick={this.handleAddUserDefined}
                        onKeyUp={this.handleAddUserDefined}
                      >
                        {translate('modal.button.add_user_defined')}
                      </a>
                    </div>
                  </h3>
                  <div
                    className={`error ${appliedUserdefinedErrorClass}`}
                    style={{
                      marginTop: '6px',
                      marginLeft: '5px',
                      fontSize: '12px',
                      fontWeight: '700',
                      color: '#ef4136',
                    }}
                  >
                    {appliedUserDefinedError}
                  </div>
                  <div className="setting_popup_content">
                    <div className="table_wrap table_type_3" style={{ padding: '0 10px', border: '1px solid #e5e5e5', borderRadius: '5px' }}>
                      <table className="table table_type_3" style={{ tableLayout: 'fixed' }}>
                        <colgroup>
                          <col style={{ width: '3.7%' }} />
                          <col style={{ width: '35%' }} />
                          <col style={{ width: '20%' }} />
                          <col style={{ width: '20%' }} />
                          <col style={{ width: '20%' }} />
                        </colgroup>
                        <tbody>
                          <tr>
                            <th>
                              <Checkbox
                                checked={isUserdefinedCheckedAll}
                                onChange={this.handleUserDefinedCheckAllChange}
                                disabled={selectedUserDefinedList.length === 0}
                              />
                            </th>
                            <th>{translate('settings.list.defined_target')}</th>
                            <th>{translate('settings.list.type')}</th>
                            <th>{translate('settings.list.key_name')}</th>
                            <th>{translate('settings.list.value_detail')}</th>
                          </tr>
                          {
                            selectedUserDefinedList.length !== 0 ? (
                              selectedUserDefinedList.map((item) => {
                                return (
                                  <tr key={item.user_defined_id}>
                                    <td className="strong">
                                      <Checkbox
                                        value={item.user_defined_id}
                                        checked={userDefinedValues.indexOf(item.user_defined_id) > -1}
                                        onChange={this.handleUserDefinedCheckChange}
                                      />
                                    </td>
                                    <td className="strong">
                                      {item.target}
                                    </td>
                                    <td className="strong">
                                      {this.renderTypeValue(item)}
                                    </td>
                                    <td className="strong">
                                      {this.renderKeyName(item)}
                                    </td>
                                    <td className="strong">
                                      {this.renderKeyNameDetail(item)}
                                    </td>
                                  </tr>
                                );
                              })
                            ) : null
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="setting_popup_content_wrap">
                  <h3
                    className="content_title"
                    ref={this.projectMB}
                  >
                    {translate('modal.title.project_member')}
                    (
                    {selectedMemberList.length}
                    )
                    <div className="button_box">
                      <a
                        className="delete_button"
                        style={{ cursor: 'pointer' }}
                        onClick={this.handleRemoveUser}
                        onKeyUp={this.handleRemoveUser}
                      >
                        {translate('modal.button.delete')}
                      </a>
                      <a
                        className="add_button"
                        style={{ cursor: 'pointer' }}
                        onClick={this.handleAddUser}
                        onKeyUp={this.handleAddUser}
                      >
                        {translate('modal.button.add_user')}
                      </a>
                      <a
                        className="add_button"
                        style={{ cursor: 'pointer' }}
                        onClick={this.handleAddGroup}
                        onKeyUp={this.handleAddGroup}
                      >
                        {translate('modal.button.add_group')}
                      </a>
                    </div>
                  </h3>
                  <div className="setting_popup_content">
                    <div
                      className="table_wrap table_type_3"
                      style={{
                        padding: '0 10px',
                        border: '1px solid #e5e5e5',
                        borderRadius: '5px',
                      }}
                    >
                      <table className="table table_type_3">
                        <colgroup>
                          <col style={{ width: '3.7%' }} />
                          <col style={{ width: '8%' }} />
                          <col style={{ width: '55%' }} />
                          <col style={{ width: '20%' }} />
                          <col style={{ width: '13%' }} />
                        </colgroup>
                        <tbody>
                          <tr>
                            <th>
                              <Checkbox
                                checked={itemsChecked}
                                onChange={this.handleMemberCheckAll}
                                disabled={selectedMemberList.length === 0}
                              />
                            </th>
                            <th>{translate('settings.list.type')}</th>
                            <th>{translate('system.list.name')}</th>
                            <th>{translate('settings.list.email')}</th>
                            <th className="tac">{translate('modal.title.assigned')}</th>
                          </tr>
                          {
                            selectedMemberList.length !== 0 ? (
                              selectedMemberList.map((list) => {
                                if (list.type === 'group') {
                                  return (
                                    <tr key={`${list.type}_${list.id}`}>
                                      <td className="strong">
                                        <Checkbox
                                          value={`${list.type}_${list.id}`}
                                          checked={checkValue.indexOf(`${list.type}_${list.id}`) > -1}
                                          onChange={this.handleMemberCheckChange}
                                          disabled={list.email === state.user.email}
                                        />
                                      </td>
                                      <td className="string">{translate('settings.list.group')}</td>
                                      <td className="strong">
                                        <img
                                          src={this.getProfileImg(list.id)}
                                          alt=""
                                          style={{ width: '17px', height: '17px', borderRadius: '50%' }}
                                        />
                                        &nbsp;
                                        {' '}
                                        {list.name}
                                      </td>
                                      <td className="strong">-</td>
                                      <td className="strong" style={{ textAlign: 'center' }}>-</td>
                                    </tr>
                                  );
                                }
                                return (
                                  <tr key={`${list.type}_${list.id}`}>
                                    <td className="strong">
                                      <Checkbox
                                        value={`${list.type}_${list.id}`}
                                        checked={checkValue.indexOf(`${list.type}_${list.id}`) > -1}
                                        onChange={this.handleMemberCheckChange}
                                        disabled={list.email === state.user.email}
                                      />
                                    </td>
                                    <td className="string">{translate('settings.list.user')}</td>
                                    {
                                      list.email === state.user.email ? (
                                        <td className="strong">
                                          <img
                                            src={this.getProfileImg(list.id)}
                                            alt=""
                                            style={{ width: '17px', height: '17px', borderRadius: '50%' }}
                                          />
                                          &nbsp;
                                          {list.profile}
                                          (
                                          {translate('contents_header.place_holder.project_owner')}
                                          )
                                        </td>
                                      ) : (
                                        <td className="strong">
                                          <img
                                            src={this.getProfileImg(list.id)}
                                            alt=""
                                            style={{ width: '17px', height: '17px', borderRadius: '50%' }}
                                          />
                                          &nbsp;
                                          {list.profile}
                                        </td>
                                      )
                                    }
                                    <td className="strong">{this.convertToString(list.email)}</td>
                                    <td className="strong" style={{ textAlign: 'center' }}>-</td>
                                  </tr>
                                );
                              })
                            ) : null
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </Scrollbars>
            <div className="setting_popup_button_wrap">
              <a
                className="button cencel_button"
                style={{ cursor: 'pointer' }}
                onClick={this.closeNewProjectModal}
                onKeyUp={this.closeNewProjectModal}
              >
                {translate('modal.button.cancel')}
              </a>
              <a
                className="button save_button"
                style={{ cursor: 'pointer' }}
                onClick={this.handleSave}
                onKeyUp={this.handleSave}
              >
                {translate('modal.button.save')}
              </a>
            </div>
          </div>
        </div>
        <AssigningUserModal
          isOpenMAU={isOpenMAU}
          closeModal={this.handleMAUClose}
          completeCallback={this.handleMemberList}
          projectName={projectName}
          location={location}
          members={selectedMemberList}
          translate={translate}
        />
        <ApplyingPolicyModal
          isOpenMAC={isOpenMAC}
          closeModal={this.handleMACClose}
          excludeIds={excludePolicyIds}
          completeCallback={this.handlePolicyList}
          translate={translate}
        />
        <AssigningGroupModal
          isOpenMAG={isOpenMAG}
          closeModal={this.handleMAGClose}
          excludeIds={selectedGroupIds}
          completeCallback={this.handleMemberList}
          translate={translate}
        />
        <AddUserDefinedModal
          isOpenMUD={isOpenMUD}
          selectedUserDefinedList={selectedUserDefinedList}
          closeModal={this.handleMUDClose}
          handleAddCallback={this.handleAddUserDefinedCallback}
          translate={translate}
        />
        <Modal open={modalAlert} onClose={this.handleCloseAlert}>
          {isLoader ? (
            <Loader />
          ) : (
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{modalAlertTitle}</h2>
                  <p className="text">{modalAlertMsg}</p>
                  <div className="button_wrap">
                    <a
                      className="center_button"
                      onClick={this.handleCloseAlert}
                      onKeyUp={this.handleCloseAlert}
                    >
                      {translate('modal.button.ok')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal>
        <Modal open={isOpenAttentionModal} onClose={this.closeAttentionModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    onClick={this.closeAttentionModal}
                    onKeyUp={this.closeAttentionModal}
                  >
                    {translate('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Modal>
    );
  }
}

export default WithRouter(inject('state')(observer(NewProjectModal)));
